import type { CSSProperties } from 'react';

export const styles = {
  ellipsis: (delay: number, style: CSSProperties = {}) => ({
    opacity: 0,
    animationDelay: `${delay}ms`,
    animationName: 'opacity-loop',
    // animationDuration: '1.3s',
    animationDuration: '1000ms',
    animationIterationCount: 'infinite',
    padding: '0 0.1rem',
    ...style,
  }),
};
